import { useEffect, useState } from "react";
import ActionListItem from "./ActionListItem";
import TimeLineForm from "./TimelineForm";
import ListShort from "components/ui/atoms/ListShort";
import { useAllAction } from "models/actions/apiAction";
import { useModal } from "@ebay/nice-modal-react";

const defaultFilter = {
  ordering: "-date",
  past_events: true,
};

const TimeLine = ({ companyDomains, peopleAddresses, state, setState }) => {
  const [fetchParams, setFetchParams] = useState(null);
  const { data: actions, status, error } = useAllAction(fetchParams);
  const actionModal = useModal("ActionDrawer");

  useEffect(
    () =>
      setFetchParams({
        ...defaultFilter,
        ...state?.filter,
        action_links__domain: companyDomains,
        action_links__email_address: peopleAddresses,
        offset: state.offset || 0,
      }),
    [state],
  );

  return (
    <>
      <ListShort
        title="Timeline"
        emptyMessage="No actions"
        resource={actions}
        resourceStatus={status}
        state={state}
        setState={setState}
        ListItemComponent={ActionListItem}
        FilterForm={TimeLineForm}
        primaryClick={(event) => actionModal.show({ id: event.id })}
        error={error}
        pagination
      />
    </>
  );
};

export default TimeLine;
